import React from "react";
import styles from "./ClaimOwnershipModal.module.scss";

const HeroImage = ({ imageUrl, variant = "compact", align = "center" }) => {
  if (!imageUrl) return null;
  const sizeClass =
    variant === "full" ? styles.heroImageFull : styles.heroImageCompact;
  const alignClass =
    align === "left" ? styles.heroImageLeft : styles.heroImageCenter;
  return (
    <div className={`${styles.heroImage} ${sizeClass} ${alignClass}`}>
      <img src={imageUrl} alt="" />
    </div>
  );
};

export default HeroImage;
